import styled from 'styled-components';
import { secondaryColors } from '@tryhackme/thm-ui-components';

export const StyledTickets = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  gap: 0 1.5rem;

  > div > div {
    margin-bottom: 1.2rem;
  }
`;

export const StyledTicketCategoryWrapper = styled.div<{ isHovered: boolean }>`
  display: flex;
  gap: 1.5rem;
  position: relative;

  > div:nth-child(-n + 3) {
    border-style: ${({ isHovered }) => isHovered && 'solid'};
  }
`;

export const StyledHoverButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 1.2rem);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledFooter = styled.div<{ $isDark?: boolean }>`
  display: block;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  padding: 1.8rem;
  width: 100%;
  background: ${({ theme }) => theme.colors.info.lightest};
  border-radius: 0.5rem;
  text-align: center;
  color: ${({ theme, $isDark }) => ($isDark ? theme.colors.white : secondaryColors.black)};
`;
